import type { FC, ReactNode } from "react";
import { useMemo } from "react";

import classNames from "classnames";
import { useSelector } from "react-redux";

import { PopupHoverContainer } from "@similarweb/ui-components";

import type { RootState } from "single-spa/store/types";

import { resolveSegmentType, SegmentType } from "../../../../pages/segments/analysis/utils/resolveSegmentsType";

import { SegmentTooltipContent } from "./SegmentTooltipContent";

/**
 * a Tooltip that that shows an segment description
 */

interface ISegmentTooltipProps {
    domain?: string;
    segmentName?: string;
    segmentId: string;
    onClick?: () => void;
    isOrgSegment?: boolean;
    dateModified?: string;
    placement?: string;
    debounce?: number;
    cssClassContainer?: string;
    children: ReactNode;
}

const SEGMENT_TYPE_HEIGHT: Record<SegmentType, number> = {
    [SegmentType.MySegment]: 204,
    [SegmentType.AccountSegment]: 204,
};

export const SegmentTooltip: FC<ISegmentTooltipProps> = (props) => {
    const { segmentId, placement = "top-left" } = props;
    const segmentsModule = useSelector((state: RootState) => state.segmentsModule);
    const segmentType = useMemo(() => resolveSegmentType(segmentId, segmentsModule), [segmentId, segmentsModule]);
    const height = segmentType ? SEGMENT_TYPE_HEIGHT[segmentType] : 204;
    return (
        <PopupHoverContainer
            content={() => (
                <SegmentTooltipContent
                    {...props}
                    // @ts-ignore FIXME: strict migration - resolveSegmentType may return undefined; SegmentTooltipContent renders nothing without a valid segmentType
                    segmentType={segmentType}
                    height={height}
                />
            )}
            config={{
                placement,
                cssClassContent: "Popup-content-infoCard",
                cssClassContainer: classNames("Popup-Container-infoCard", props.cssClassContainer),
                width: 394,
                height,
                allowHover: true,
                closeDelay: 50,
            }}
            debounce={props.debounce}
        >
            {props.children}
        </PopupHoverContainer>
    );
};
